import MediaShilo from '@/shared/assets/png/shilo.webp';
import MediaCycle from '@/shared/assets/svg/circle.svg';
import MediaDot from '@/shared/assets/svg/dots.svg';

const MediaFigure = () => (
  <figure className="wrapper-media">
    <img className="media__dot" src={MediaDot} alt="" aria-hidden="true" />
    <img className="media__cycle" src={MediaCycle} alt="" aria-hidden="true" />
    <img className="media__image" src={MediaShilo} alt="Шило" />
  </figure>
);

export default MediaFigure;
